module.exports = __webpack_public_path__ + "static/media/mitch-sky.c09a80d4.png";